import React from 'react';

const TileContext = React.createContext();

export default TileContext;